import React from "react";
import TableSortLabel from "@mui/material/TableSortLabel";
import { ChevronDownIcon as ExpandMoreIcon } from "../../icons";
const SortIcon = ({ id, name, property, activeSort, startReverse = false, handleSort, }) => {
    const activeSortDirection = activeSort.reverse ? "desc" : "asc";
    const nonActiveSortDirection = startReverse ? "desc" : "asc";
    const isActiveProperty = activeSort.property === property;
    return (React.createElement(TableSortLabel, { id: id, active: isActiveProperty, onClick: () => handleSort({
            property,
            reverse: isActiveProperty ? !activeSort.reverse : startReverse,
        }), direction: isActiveProperty ? activeSortDirection : nonActiveSortDirection, IconComponent: ExpandMoreIcon }, name));
};
export default SortIcon;
//# sourceMappingURL=SortIcon.js.map